import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import { colorsPalette, MIDDLE_MARGIN, SMALL_MARGIN } from '../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    headerDescription: {
      marginTop: SMALL_MARGIN,
      color: colorsPalette.gray,
      lineHeight: 1.5,
      fontSize: 18,
      maxWidth: 794,
      [theme.breakpoints.up('md')]: {
        fontSize: 20,
        marginTop: MIDDLE_MARGIN,
      },
    },
  }),
);

export default useStyles;
